import { queryListPermissions, querySavePermission } from './service';
import _ from 'lodash';

const Model = {
  namespace: 'processUsers',

  state: {
    id: null,
    processSearchCriteria: '',
    processId: null,
    newPermission: false,
    listUserPermission: null,
    listPositionPermission: null,
    listUserGroupPermission: null,
    successPermission: false,
  },

  effects: {
    *fetchListPermissions({ payload }, { call, put }) {
      try {
        const response = yield call(queryListPermissions, payload);
        yield put({
          type: 'queryPermission',
          payload: {
            data: response,
            name: payload.name,
            field: payload.field,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addListPermission({ payload }, { put }) {
      yield put({
        type: 'addListPermissions',
        payload,
      });
    },

    *deleteItemPermision({ payload }, { put }) {
      yield put({
        type: 'deleteItemPermisions',
        payload,
      });
      yield put({
        type: `global/modalConfirm`,
        state: false,
        id: null,
      });
    },

    *savePermission({ payload }, { call, put }) {
      try {
        yield call(querySavePermission, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'savePermissions',
          payload: true,
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },

    *addNewPermission({ payload }, { put }) {
      yield put({
        type: 'addPermission',
        payload,
      });
    },

    *hideNewPermission({ payload = 'hidePermission' }, { put }) {
      yield put({
        type: payload,
      });
    },
  },

  reducers: {
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    addPermission(state, { payload }) {
      return {
        ...state,
        newPermission: payload.state,
        newReportGroup: false,
        selectedItem: payload.item,
      };
    },

    queryPermission(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.map(payload.data, (l) => {
          return {
            ...l[payload.field],
            id: l[`${payload.field}Id`],
          };
        }),
      };
    },

    addListPermissions(state, { payload }) {
      return {
        ...state,
        [payload.name]: [...state[payload.name], payload.data],
      };
    },

    deleteItemPermisions(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.filter(state[payload.name], (l) => l.id !== payload.id),
      };
    },
    savePermissions(state, { payload }) {
      return {
        ...state,
        successPermission: payload,
      };
    },

    hidePermission(state) {
      return {
        ...state,
        selectedItem: null,
        listUserPermission: null,
        listPositionPermission: null,
        listUserGroupPermission: null,
        formConfig: null,
        successPermission: false,
      };
    },
  },
};

export default Model;
